import * as fromDatatype from "../../../../models/datatype-library";

export class RecurringEventViewCriteriaDtoModel {
    guids?: any [];
    server_doc_type?: string;
    client_doc_type?: string;
    doc_entity_hdr_guids?: any [];
    sales_entity_hdr_guids?: any [];
    guid_comps?: any [];
    guid_branches?: any [];
    guid_stores?: any [];
    code_companies?: any [];
    code_branches?: any [];
    code_locations?: any []; 
    date_txn_to?: fromDatatype.TimestampTzDatatypeInterface;
    date_txn_from?: fromDatatype.TimestampTzDatatypeInterface;
  }
  